import { FC } from "react";
import SearchTable from "../../../components/template/Search/SearchTable";
import { TableConfig } from "../../../types/Components/Table/TableConfig";
import { PaginationConfig } from "../../../types/Components/Table/PaginationConfig";

interface IndicatorAlertsProps {
  tableConfig: TableConfig;
  paginationConfig: PaginationConfig;
}

const IndicatorAlerts: FC<IndicatorAlertsProps> = ({
  tableConfig,
  paginationConfig,
}) => {
  return (
    <SearchTable
      searchTableName="Factor de alerta dos indicadores"
      headingFontSize="2xl"
      tableConfig={tableConfig}
      paginationConfig={paginationConfig}
    ></SearchTable>
  );
};

export default IndicatorAlerts;
